import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';

import { AccessCardComponent } from './access-card/access-card.component';
import { InformationCardComponent } from './information-card/information-card.component';
import { StateCardComponent } from './state-card/state-card.component';

export const TokenInformationTabView = (): React.JSX.Element => {
  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack gap={GapEnum.M} flex={1}>
      <Stack flex={1} gap={GapEnum.M} direction="column">
        <InformationCardComponent />
        <StateCardComponent />
      </Stack>
      <Stack flex={1}>
        <AccessCardComponent />
      </Stack>
    </Stack>
  );
};
